// Set $debug = true in the console to activate extra logging goodies.
export default function debug(
  cb: () => void,
  flagName: '$debug' | '$measurePerf' = '$debug'
): void {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if ((globalThis as any)?.[flagName] === true) {
    return cb();
  }
}
